<div *ngIf="isPageReady" class="flex flex-col h-full gap-4">

  <!-- Frequency Selection -->
  <div class="flex flex-col gap-3">
    <label class="font-semibold text-sm text-color-secondary">Recurrence Frequency</label>
    <div class="flex gap-6 items-center">
      <div class="flex items-center gap-2">
        <p-radioButton [value]=RRule.DAILY [(ngModel)]="rruleOptions.freq" inputId="recurD"
          (ngModelChange)="freqChanged($event)" />
        <label for="recurD">Daily</label>
      </div>
      <div class="flex items-center gap-2">
        <p-radioButton [value]=RRule.WEEKLY [(ngModel)]="rruleOptions.freq" inputId="recurW"
          (ngModelChange)="freqChanged($event)" />
        <label for="recurW">Weekly</label>
      </div>
      <div class="flex items-center gap-2">
        <p-radioButton [value]=RRule.MONTHLY [(ngModel)]="rruleOptions.freq" inputId="recurM"
          (ngModelChange)="freqChanged($event)" />
        <label for="recurM">Monthly</label>
      </div>
    </div>
  </div>

  <p-divider class="-my-1" />

  <!-- Daily Options -->
  <div *ngIf="rruleOptions.freq === RRule.DAILY" class="flex items-center gap-2">
    <span>Every</span>
    <input type="number" min="1" max="365" pInputText class="text-center" style="width: 60px;"
      [(ngModel)]="rruleOptions.interval" (ngModelChange)="scheduleChanged()" />
    <span>day(s)</span>
  </div>

  <!-- Weekly Options -->
  <div *ngIf="rruleOptions.freq === RRule.WEEKLY" class="flex flex-col gap-3">
    <div class="flex items-center gap-2">
      <span>Every</span>
      <input type="number" min="1" max="52" pInputText class="text-center" style="width: 60px;"
        [(ngModel)]="rruleOptions.interval" (ngModelChange)="scheduleChanged()" />
      <span>week(s) on</span>
    </div>
    <div class="flex flex-wrap gap-x-4 gap-y-2">
      <div *ngFor="let day of [
        { value: RRule.MO, label: 'Mon', id: 'bwdMo' },
        { value: RRule.TU, label: 'Tue', id: 'bwdTu' },
        { value: RRule.WE, label: 'Wed', id: 'bwdWe' },
        { value: RRule.TH, label: 'Thu', id: 'bwdTh' },
        { value: RRule.FR, label: 'Fri', id: 'bwdFr' },
        { value: RRule.SA, label: 'Sat', id: 'bwdSa' },
        { value: RRule.SU, label: 'Sun', id: 'bwdSu' }
      ]" class="flex items-center gap-2">
        <p-radioButton [value]="day.value" [(ngModel)]="byweekday" [inputId]="day.id"
          (ngModelChange)="scheduleChanged()" />
        <label [for]="day.id">{{ day.label }}</label>
      </div>
    </div>
  </div>

  <!-- Monthly Options -->
  <div *ngIf="rruleOptions.freq === RRule.MONTHLY" class="flex flex-col gap-3">
    <div class="flex gap-6 items-center">
      <div class="flex items-center gap-2">
        <p-radioButton [value]=true [(ngModel)]="isMonthDay" inputId="imdT"
          (ngModelChange)="isMonthDayChanged($event)" />
        <label for="imdT">By day of month</label>
      </div>
      <div class="flex items-center gap-2">
        <p-radioButton [value]=false [(ngModel)]="isMonthDay" inputId="imdF"
          (ngModelChange)="isMonthDayChanged($event)" />
        <label for="imdF">By day of week</label>
      </div>
    </div>

    <!-- By Day of Month -->
    <div *ngIf="isMonthDay" class="flex items-center gap-2">
      <span>Every</span>
      <input type="number" min="1" max="12" pInputText class="text-center" style="width: 60px;"
        [(ngModel)]="rruleOptions.interval" (ngModelChange)="scheduleChanged()" />
      <span>month(s) on day</span>
      <input type="number" min="1" max="31" pInputText class="text-center" style="width: 60px;"
        [(ngModel)]="rruleOptions.bymonthday" (ngModelChange)="scheduleChanged()" />
    </div>

    <!-- By Day of Week of Month -->
    <div *ngIf="!isMonthDay" class="flex flex-col gap-3">
      <div class="flex items-center gap-2 flex-wrap">
        <span>Every</span>
        <input type="number" min="1" max="12" pInputText class="text-center" style="width: 60px;"
          [(ngModel)]="rruleOptions.interval" (ngModelChange)="scheduleChanged()" />
        <span>month(s) on the</span>
        <p-select [options]="RRuleFns.weekInMonthList" [(ngModel)]="rruleOptions.bysetpos"
          (ngModelChange)="scheduleChanged()" optionLabel="name" optionValue="value"
          placeholder="Select" class="w-28" />
      </div>
      <div class="flex flex-wrap gap-x-4 gap-y-2">
        <div *ngFor="let day of [
          { value: RRule.MO, label: 'Mon', id: 'bwdMoM' },
          { value: RRule.TU, label: 'Tue', id: 'bwdTuM' },
          { value: RRule.WE, label: 'Wed', id: 'bwdWeM' },
          { value: RRule.TH, label: 'Thu', id: 'bwdThM' },
          { value: RRule.FR, label: 'Fri', id: 'bwdFrM' },
          { value: RRule.SA, label: 'Sat', id: 'bwdSaM' },
          { value: RRule.SU, label: 'Sun', id: 'bwdSuM' }
        ]" class="flex items-center gap-2">
          <p-radioButton [value]="day.value" [(ngModel)]="byweekday" [inputId]="day.id"
            name="monthlyWeekday" (ngModelChange)="scheduleChanged()" />
          <label [for]="day.id">{{ day.label }}</label>
        </div>
      </div>
    </div>
  </div>

  <p-divider class="-my-1" />

  <!-- Date Range & Count -->
  <div class="flex flex-col gap-2">
    <label class="font-semibold text-sm text-color-secondary">Schedule Range</label>
    <div class="flex gap-3 items-end">
      <div class="flex flex-col gap-1">
        <label class="text-xs text-color-secondary">Start Date</label>
        <p-datepicker [(ngModel)]="rruleOptions.dtstart" (ngModelChange)="scheduleChanged()" />
      </div>
      <div class="flex flex-col gap-1">
        <label class="text-xs text-color-secondary">Until Date</label>
        <p-datepicker [(ngModel)]="rruleOptions.until" (ngModelChange)="scheduleChanged()" />
      </div>
      <div class="flex flex-col gap-1">
        <label class="text-xs text-color-secondary">Count</label>
        <input type="number" min="0" max="100" pInputText class="text-center" style="width: 60px;"
          [(ngModel)]="rruleOptions.count" (ngModelChange)="scheduleChanged()" />
      </div>
    </div>
  </div>

  <!-- Preview -->
  <div *ngIf="rruleDates != null && rruleDates.length > 0" class="flex flex-col gap-2 grow min-h-0">
    <div class="text-sm text-color-secondary">
      <i class="pi pi-calendar mr-1"></i>
      <span class="font-semibold">{{ rruleText }}</span>
      <span *ngIf="!hasEnd" class="ml-1">(first 10 shown)</span>
    </div>
    <div class="grow min-h-0" style="min-height: 120px;">
      <prox-ag-grid [gridOptions]="rruleGridOptions" [rowData]="rruleDates" [hasFooter]=false />
    </div>
  </div>

  <!-- Spacer only when no preview grid -->
  <div *ngIf="!rruleDates || rruleDates.length === 0" class="grow"></div>

  <!-- Footer -->
  <div class="flex justify-end gap-2 pt-2">
    <p-button label="Cancel" icon="pi pi-times" severity="secondary" size="small" (onClick)="cancel()" />
    <p-button label="Ok" icon="pi pi-check" size="small" (onClick)="ok()" />
  </div>
</div>
